import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const InviteUserCreateableLabel: FC<{ value: string }> = ({ value }) => (
  <FormattedMessage
    id="invite.with.label"
    values={{
      label: <strong>{value}</strong>,
    }}
  />
);
